(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26],{

/***/ 55792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(30302);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dashboard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/FirebaseClaims.tsx
var FirebaseClaims = __webpack_require__(93598);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/next/RouterQuery.tsx
var RouterQuery = __webpack_require__(72579);
// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 5 modules
var generated = __webpack_require__(20229);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/hooks/useThrottleSubscription.ts
var useThrottleSubscription = __webpack_require__(72605);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/apollo/index.ts + 9 modules
var apollo = __webpack_require__(34217);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
;// CONCATENATED MODULE: ../../libs/frontend-utils/src/dataExport.ts



const DETAILED_DATA_HEADER = [
    "Created At",
    "Client",
    "Job",
    "Interviewer",
    "Job Location",
    "Applicant",
    "Phone Number",
    "Channel",
    "Vetted",
    "Status",
    "Passed by Vetter"
];
const PERFORMANCE_DATA_HEADER = [
    "Client",
    "Job",
    "Vetted",
    "Passed by Vetter",
    "Internal Interviewer",
    "External Interviewer"
];
const quoteTextWithComma = (text)=>text.includes(",") ? '"'.concat(text, '"') : text;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const exportCSV = function(rows) {
    let fileName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vette_data";
    const csvContent = "data:text/csv;charset=utf-8," + rows.map((row)=>row.map((val)=>typeof val === "string" ? quoteTextWithComma(val) : val).join(",")).join("\n");
    const encodedURI = encodeURI(csvContent);
    const escapedEncodedURI = encodedURI.replace(/#/g, "%23");
    const link = document.createElement("a");
    link.setAttribute("href", escapedEncodedURI);
    link.setAttribute("download", "".concat(fileName, ".csv"));
    document.body.appendChild(link);
    link.click();
};
const importCSV = (file)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener("load", (e)=>{
            var ref;
            const data = (ref = e.target) === null || ref === void 0 ? void 0 : ref.result;
            const rows = data.split(/\r\n|\n|\r/).map((r)=>r.trim());
            const rowsWithColumns = rows.map((r)=>r.split(/,|, | , | ,/).map((c)=>c.trim()));
            resolve(rowsWithColumns);
        });
        reader.addEventListener("error", ()=>{
            reject(new Error("CSV file could not be read"));
        });
        reader.readAsText(file);
    });
};
const exportDetailedData = async (clientId)=>{
    const apolloClient = (0,apollo/* getApolloClient */.W)();
    try {
        const { data  } = await apolloClient.query({
            query: generated/* ClientExportDetailedDataDocument */.wUm,
            variables: {
                clientId
            }
        });
        if (!data.clientExportDetailedData) throw new Error("No data");
        const orderedRows = data.clientExportDetailedData.map((param)=>{
            let { createdAt , client , job , interviewer , location , applicant , phone , channel , vetted , status , passed  } = param;
            return [
                createdAt,
                client,
                job,
                interviewer,
                location,
                applicant,
                phone,
                channel,
                vetted,
                status,
                passed
            ];
        });
        exportCSV([
            DETAILED_DATA_HEADER,
            ...orderedRows
        ], "detailed data export - " + new Date().toISOString());
    } catch (e) {
        console.log(e.message);
        message/* message.error */.y.error("Failed to export detailed data");
    }
};
const exportPerformanceData = async (clientId)=>{
    const apolloClient = (0,apollo/* getApolloClient */.W)();
    try {
        const { data  } = await apolloClient.query({
            query: generated/* ClientExportPerformanceDataDocument */.j7d,
            variables: {
                clientId
            }
        });
        if (!data.clientExportPerformanceData) throw new Error("No data");
        const orderedRows = data.clientExportPerformanceData.map((param)=>{
            let { client , job , vetted , passed , internalInterviewer , externalInterviewer  } = param;
            return [
                client,
                job,
                vetted,
                passed,
                internalInterviewer,
                externalInterviewer
            ];
        });
        exportCSV([
            PERFORMANCE_DATA_HEADER,
            ...orderedRows
        ], "performance data export - " + new Date().toISOString());
    } catch (e) {
        message/* message.error */.y.error("Failed to export performance data");
    }
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(94187);
// EXTERNAL MODULE: ../../node_modules/antd/es/dropdown/index.js + 2 modules
var dropdown = __webpack_require__(67111);
// EXTERNAL MODULE: ../../node_modules/antd/es/menu/index.js + 5 modules
var es_menu = __webpack_require__(58579);
// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 3 modules
var es_tooltip = __webpack_require__(55003);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(48562);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(63610);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/QuestionCircleFilled.js
var QuestionCircleFilled = __webpack_require__(50733);
var QuestionCircleFilled_default = /*#__PURE__*/__webpack_require__.n(QuestionCircleFilled);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/InfoCircleFilled.js
var InfoCircleFilled = __webpack_require__(93469);
var InfoCircleFilled_default = /*#__PURE__*/__webpack_require__.n(InfoCircleFilled);
;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/Dashboard/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n  padding: 36px;\n  overflow-y: auto;\n  z-index: 1;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 1;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 84px 48px 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr) 1.4fr;\n  gap: 24px;\n  margin-top: 24px;\n  padding: 36px;\n  max-height: 400px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  padding: 37px 34px 40px 33px;\n  flex-direction: column;\n  border-radius: 18px;\n  justify-content: center;\n  align-items: center;\n  background: ",
        ";\n  height: 387px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    font-size: ",
        "px;\n    line-height: 120%;\n    color: ",
        ";\n  }\n  text-align: center;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  .ant-skeleton-title {\n    border-radius: 18px;\n    height: 100%;\n    display: flex;\n    flex: 1;\n    margin-top: 0;\n  }\n  height: 387px;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stroke-width: 100 !important;\n  stroke: black !important;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 166px;\n  height: 48px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 106px;\n  display: flex;\n  gap: 4px;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  width: 100%;\n  background: url(",
        ") no-repeat center center;\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  vertical-align: initial;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  gap: 27px;\n  padding-top: 40px;\n  padding-left: 40px;\n  flex-direction: column;\n  border-radius: 18px;\n  background: linear-gradient(136.75deg, #000000 22.72%, #251444 74.25%);\n  height: 387px;\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}






const Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
const Header = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
const Heading = (0,styled_components_browser_esm/* default */.ZP)(styles/* Title */.Dx)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const Cards = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const PrimaryText = (0,styled_components_browser_esm/* default */.ZP)(styles/* Title */.Dx)(_templateObject5(), (param)=>{
    let { $size  } = param;
    return $size ? $size : "64";
}, (param)=>{
    let { theme , $color  } = param;
    return $color ? "$color" : theme.colors.grey100;
});
const Label = (0,styled_components_browser_esm/* default */.ZP)(styles/* Text */.xv)(_templateObject6(), (param)=>{
    let { theme , $color  } = param;
    return $color ? "$color" : theme.colors.grey100;
}, (param)=>{
    let { $align  } = param;
    return $align ? "center" : "";
});
const SkeletonCard = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).attrs({
    title: true,
    paragraph: false,
    active: true
})(_templateObject7());
const DropdownOutlined = (0,styled_components_browser_esm/* default */.ZP)(DownOutlined/* default */.Z)(_templateObject8());
const styles_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject9());
const CardBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10());
const ImageWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11(), (param)=>{
    let { $src  } = param;
    return $src;
}, (param)=>{
    let { offsetY  } = param;
    return "background-position-y: ".concat(offsetY);
}, (param)=>{
    let { backgroundSize  } = param;
    return "background-size: ".concat(backgroundSize);
}, (param)=>{
    let { offsetX  } = param;
    return "background-position-x: ".concat(offsetX);
}, (param)=>{
    let { grayscale  } = param;
    return " ".concat(grayscale ? "filter: grayscale(1)" : "", " ");
}, (param)=>{
    let { opacity  } = param;
    return "opacity: ".concat(opacity);
});
const QuestionIcon = (0,styled_components_browser_esm/* default */.ZP)((QuestionCircleFilled_default()))(_templateObject12(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey60;
});
const InfoIcon = (0,styled_components_browser_esm/* default */.ZP)((InfoCircleFilled_default()))(_templateObject13(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey30;
});
const lastCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14());

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Space/styles.ts
var Space_styles = __webpack_require__(81983);
;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/Dashboard/DashboardCard.tsx





const DashboardCard = (param)=>{
    let { src , label , imageOffsetY , tooltip , children , loading , backgroundSize , grayscale =false , opacity  } = param;
    const body = /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
        $align: true,
        $size: 18,
        $weight: 600,
        children: label
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonCard, {
        active: true,
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrap, {
                    $src: src,
                    offsetY: imageOffsetY,
                    backgroundSize: backgroundSize,
                    grayscale: grayscale,
                    opacity: opacity
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody, {
                    children: [
                        tooltip ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                            direction: "horizontal",
                            size: 5,
                            align: "center",
                            children: [
                                body,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_tooltip/* default */.Z, {
                                    title: tooltip,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionIcon, {})
                                })
                            ]
                        }) : body,
                        children
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/Dashboard/index.tsx










const Dashboard = (param)=>{
    let { clientId , userId  } = param;
    var ref, ref1;
    const { data , loading , refetch  } = (0,generated/* useClientDashboardQuery */.Pk0)({
        variables: {
            clientId,
            userId
        }
    });
    useThrottleSubscription/* useThrottleSubscription */.i(refetch, 2000, generated/* useClientUpdatedSubscription */.e7h, {
        variables: {
            clientId
        }
    });
    const { available =0 , engaged =0 , passed =0 , vetted =0  } = (data === null || data === void 0 ? void 0 : data.clientDashboard) || {};
    const cardData = (0,react.useMemo)(()=>[
            {
                label: "Engaged",
                value: engaged,
                src: "/images/engaged-photo.svg",
                opacity: 0.6,
                grayscale: engaged === 0 || engaged === null,
                tooltip: "Engaged applicants are the applicants who applied to a job and were engaged via SMS."
            },
            {
                label: "Interviewed",
                value: vetted,
                src: "/images/interviewed-photo.svg",
                opacity: 0.6,
                grayscale: vetted === 0 || vetted === null,
                tooltip: "Interviewed applicants are the applicants who completed the interview."
            },
            {
                label: "Passed",
                value: passed,
                src: "/images/passed-photo.svg",
                grayscale: passed === 0 || passed === null,
                opacity: 1,
                tooltip: "Passed applicants are the applicants who passed the interview."
            },
            {
                label: "External Vettes",
                value: available
            }
        ], [
        available,
        engaged,
        passed,
        vetted
    ]);
    const newEnum = {
        "SESSION-DATA": "SESSION-DATA",
        "AGGREGATED-DATA": "AGGREGATED-DATA"
    };
    const exportData = (key)=>{
        if (key === newEnum["SESSION-DATA"]) {
            exportDetailedData(clientId);
        } else if (key === newEnum["AGGREGATED-DATA"]) {
            exportPerformanceData(clientId);
        }
    };
    const menu = /*#__PURE__*/ (0,jsx_runtime.jsx)(es_menu/* default */.Z, {
        onClick: (e)=>exportData(e.key),
        items: [
            {
                label: "Export session data",
                key: "SESSION-DATA"
            },
            {
                label: "Export aggregated data",
                key: "AGGREGATED-DATA"
            }
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                className: "dashboard-manager",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        children: (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.firstName) ? "Hi ".concat(data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.firstName) : "Dashboard"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                        overlay: menu,
                        trigger: [
                            "click"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Button, {
                            type: "primary",
                            children: [
                                "Export data",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownOutlined, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards, {
                children: cardData.map((param)=>{
                    let { label , value , src , grayscale , opacity , tooltip  } = param;
                    return label !== "External Vettes" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardCard, {
                        loading: loading,
                        label: label,
                        src: src !== null && src !== void 0 ? src : "",
                        backgroundSize: "contain",
                        tooltip: tooltip,
                        grayscale: !loading && grayscale,
                        opacity: grayscale ? opacity : undefined,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                            children: value
                        })
                    }, label) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonCard, {
                        active: true,
                        loading: loading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lastCard, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                    direction: "vertical",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            $color: "white",
                                            $size: 18,
                                            $weight: 600,
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                            $color: "white",
                                            $weight: 400,
                                            $size: 15,
                                            children: "Your available current credit for external Vettes."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                    direction: "vertical",
                                    align: "baseline",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                                            $color: "white",
                                            $size: 36,
                                            children: value
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                            direction: "horizontal",
                                            size: 5,
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                                    $color: "white",
                                                    $size: 10,
                                                    $weight: 500,
                                                    children: "To top up please contact Vette"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrap, {
                                    $src: "/images/ellipse-photo.svg",
                                    backgroundSize: "contain",
                                    offsetX: "100%"
                                })
                            ]
                        })
                    }, label);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Card/index.tsx + 1 modules
var atoms_Card = __webpack_require__(28353);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/router/index.tsx
var src_router = __webpack_require__(86450);
// EXTERNAL MODULE: ../../node_modules/echarts-for-react/esm/index.js + 555 modules
var esm = __webpack_require__(15212);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/vetter/SessionStatusBadge/index.tsx + 1 modules
var SessionStatusBadge = __webpack_require__(43057);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/StatsChart/LegendItem.tsx




const LegendItem = (param)=>{
    let { status , recommended , stat , tooltip  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
        direction: "vertical",
        size: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                $size: 15,
                $weight: 600,
                children: stat || "-"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionStatusBadge/* SessionStatusBadge */.Q, {
                    status: status,
                    recommended: recommended,
                    tooltipText: tooltip
                })
            })
        ]
    }, "".concat(status).concat(recommended));
};

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/StatsChart/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 18%;\n  min-width: 282px;\n  position: relative;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const ChartWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject());
const TotalWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject1());
const LegendWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject2());

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/StatsChart/Legend.tsx






const Legend = (param)=>{
    let { stats  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegendWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
            direction: "vertical",
            size: 18,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LegendItem, {
                    status: generated/* SessionStatusEnum.SESSION_FINISHED_SUCCESSFULLY */.YpI.SESSION_FINISHED_SUCCESSFULLY,
                    recommended: true,
                    stat: stats.passed,
                    tooltip: "Applicants you recommended."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LegendItem, {
                    status: generated/* SessionStatusEnum.SESSION_FINISHED_SUCCESSFULLY */.YpI.SESSION_FINISHED_SUCCESSFULLY,
                    recommended: false,
                    stat: stats.failed,
                    tooltip: "Applicants you did not recommend."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LegendItem, {
                    status: generated/* SessionStatusEnum.SESSION_FINISHED_WITH_AN_ISSUE */.YpI.SESSION_FINISHED_WITH_AN_ISSUE,
                    recommended: null,
                    stat: stats.incomplete,
                    tooltip: "The interview was interrupted and couldn't be completed."
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/common-utils/src/array.ts
const arrayBuilder = ()=>{
    const array = [];
    const self = {
        add: (item)=>{
            array.push(item);
            return self;
        },
        build: ()=>array,
        addIf: (condition, item)=>{
            if (condition && item) return self.add(item);
            return self;
        }
    };
    return self;
};

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/StatsChart/index.tsx








const StatsChart = (param)=>{
    let { clientId , userId  } = param;
    const { data  } = (0,generated/* useInternalVetterStatisticsQuery */.Ga$)({
        variables: {
            clientId,
            userId
        }
    });
    const { all =0 , passed =0 , failed =0 , incomplete =0  } = (data === null || data === void 0 ? void 0 : data.internalVetterStatistics) || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
        direction: "horizontal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                        option: {
                            tooltip: {
                                show: false
                            },
                            legend: {
                                show: false
                            },
                            series: [
                                {
                                    type: "pie",
                                    radius: [
                                        "52%",
                                        "65%"
                                    ],
                                    avoidLabelOverlap: false,
                                    showEmptyCircle: true,
                                    emptyCircleStyle: {
                                        color: theme/* theme.colors.grey20 */.r.colors.grey20
                                    },
                                    itemStyle: {
                                        borderRadius: 20,
                                        borderColor: theme/* theme.colors.white */.r.colors.white,
                                        borderWidth: 2
                                    },
                                    label: {
                                        show: false
                                    },
                                    emphasis: {
                                        label: {
                                            show: false
                                        }
                                    },
                                    labelLine: {
                                        show: false
                                    },
                                    data: arrayBuilder().addIf(!!passed, {
                                        value: passed,
                                        name: "Passed Applicants",
                                        itemStyle: {
                                            color: theme/* theme.colors.green40 */.r.colors.green40
                                        }
                                    }).addIf(!!failed, {
                                        value: failed,
                                        name: "Failed Applicants",
                                        itemStyle: {
                                            color: theme/* theme.colors.red40 */.r.colors.red40
                                        }
                                    }).addIf(!!incomplete, {
                                        value: incomplete,
                                        name: "Incomplete Interviews",
                                        itemStyle: {
                                            color: theme/* theme.colors.grey40 */.r.colors.grey40
                                        }
                                    }).build()
                                }
                            ]
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                            direction: "vertical",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                    $centered: true,
                                    $size: 14,
                                    $weight: 600,
                                    children: "Total Vettes"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                    $centered: true,
                                    $size: 32,
                                    $weight: 600,
                                    style: {
                                        lineHeight: "24px"
                                    },
                                    children: all
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend, {
                stats: {
                    passed,
                    failed,
                    incomplete
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Table/index.tsx + 3 modules
var Table = __webpack_require__(78623);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/QuestionMarkTooltip/index.tsx + 1 modules
var QuestionMarkTooltip = __webpack_require__(94043);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/client/JobGroupPath/index.tsx + 1 modules
var JobGroupPath = __webpack_require__(6014);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/date.ts
var date = __webpack_require__(35838);
// EXTERNAL MODULE: ../../libs/common-utils/src/domain/session.ts
var session = __webpack_require__(52854);
;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/ApplicantsList/columns.tsx






const readonlyColumns = [
    {
        title: "Name",
        width: "136px",
        dataIndex: "applicant",
        key: "name",
        fixed: true,
        render: (applicant)=>"".concat(applicant.firstName, " ").concat(applicant.lastName)
    },
    {
        title: "Status",
        width: "144px",
        fixed: true,
        key: "status",
        render: (param)=>{
            let { canceled , recommended , reportedIssueType , reportedIssueDetail , status  } = param;
            var ref;
            return recommended === null && reportedIssueType ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                align: "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionStatusBadge/* SessionStatusBadge */.Q, {
                        size: "small",
                        recommended: recommended,
                        canceled: canceled,
                        status: status
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionMarkTooltip/* QuestionMarkTooltip */.w, {
                        title: reportedIssueType === generated/* SessionReportedIssueTypeEnum.OTHER */.cK$.OTHER ? reportedIssueDetail : (ref = session/* getIssueDescriptionByIssueType */.x8(reportedIssueType)) === null || ref === void 0 ? void 0 : ref.text
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionStatusBadge/* SessionStatusBadge */.Q, {
                size: "small",
                recommended: recommended,
                canceled: canceled,
                status: status
            });
        }
    },
    {
        title: "Job",
        width: "147px",
        key: "job",
        render: (param)=>{
            let { jobOffer  } = param;
            const { jobGroup  } = jobOffer;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobGroupPath/* JobGroupPath */.Y, {
                isJob: true,
                enabled: jobOffer.availability === generated/* JobOfferAvailabilityEnum.ACTIVE */.run.ACTIVE,
                showFullPath: true,
                name: jobOffer.title,
                path: jobGroup.path,
                isDeleted: !!jobGroup.deletedAt
            });
        }
    },
    {
        title: "Timestamp",
        width: "193px",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (createdAt)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                        $size: 15,
                        children: (0,date/* formatDateOnly */.o8)(createdAt)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                        $size: 12,
                        children: (0,date/* formatTime */.mr)(createdAt)
                    })
                ]
            })
    }
];
const columns = readonlyColumns;

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/ApplicantsList/Empty/columns.tsx




const columns_columns = (param)=>{
    let { loading  } = param;
    const render = (props)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Button */.Z.Button, {
            shape: "square",
            ...props,
            active: loading
        });
    };
    return [
        ...columns.map((column)=>({
                ...column,
                render: ()=>{
                    switch(column.key){
                        case "status":
                            return render({
                                style: {
                                    width: "64px",
                                    height: "22px"
                                },
                                size: "large",
                                shape: "round"
                            });
                        case "job":
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                                direction: "horizontal",
                                size: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Avatar */.Z.Avatar, {
                                        style: {
                                            width: "14px",
                                            height: "14px"
                                        }
                                    }),
                                    render({
                                        style: {
                                            width: column.width
                                        }
                                    })
                                ]
                            });
                        case "createdAt":
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    render({
                                        style: {
                                            width: column.width
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    render({
                                        style: {
                                            width: "45px"
                                        }
                                    })
                                ]
                            });
                        default:
                            return render({
                                style: {
                                    width: column.width
                                }
                            });
                    }
                }
            }))
    ];
};

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/ApplicantsList/Empty/styles.ts

function Empty_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  .ant-skeleton-button {\n    height: 14px;\n  }\n  & .ant-skeleton-element .ant-skeleton-button:not(.ant-skeleton-button-round) {\n    border-radius: 0;\n  }\n\n  & .ant-table-tbody > tr > td {\n    padding: 8px;\n  }\n"
    ]);
    Empty_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Empty_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: calc(100% - 100px);\n  margin: 100px 0;\n  background: rgb(255, 255, 255, 0.5);\n  background: radial-gradient(\n      13.96% 177.49% at 50.05% 53.67%,\n      ",
        " 0%,\n      rgba(255, 255, 255, 0) 100%\n    ),\n    radial-gradient(\n      48.43% 48.53% at 50.05% 53.67%,\n      ",
        " 0%,\n      rgba(255, 255, 255, 0) 100%\n    ),\n    radial-gradient(\n      48.43% 48.53% at 50.05% 53.67%,\n      ",
        " 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  top: 0;\n  z-index: ",
        ";\n\n  opacity: ",
        ";\n  transition: opacity 0.8s ease-in-out;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Empty_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Empty_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Empty_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff;\n  text-decoration: underline;\n\n  &:hover {\n    color: #fff;\n  }\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}

const styles_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(Empty_styles_templateObject());
const OverlayWrapper = styled_components_browser_esm/* default.div */.ZP.div(Empty_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme , $visible  } = param;
    return theme.styles.zIndexPriority.topOverMost + ($visible ? 1 : 0);
}, (param)=>{
    let { $loading , $visible  } = param;
    return $loading ? 0 : $visible ? 1 : 0;
});
const Icon = styled_components_browser_esm/* default.img */.ZP.img(Empty_styles_templateObject2());
const Link = styled_components_browser_esm/* default.a */.ZP.a(styles_templateObject3());

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/ApplicantsList/Empty/Overlay.tsx






const Overlay = (param)=>{
    let { userId , loading  } = param;
    var ref;
    const { data , loading: queryLoading  } = (0,generated/* useUserPresenceQuery */.Hcm)({
        fetchPolicy: "cache-first",
        variables: {
            userId
        }
    });
    const [updateUserPresence, { loading: mutationLoading  }] = (0,generated/* useUpdatePresenceMutation */.I3l)();
    const isOnline = (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.presence) === generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE;
    const areQueriesLoading = queryLoading || loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayWrapper, {
                $loading: areQueriesLoading,
                $visible: !isOnline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                    direction: "vertical",
                    size: 24,
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                            direction: "vertical",
                            size: 10,
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    src: "/images/rocket.svg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                                    direction: "vertical",
                                    size: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                            $align: "center",
                                            level: 3,
                                            children: "Get Started"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                            $centered: true,
                                            $size: 15,
                                            $color: theme/* theme.colors.grey40 */.r.colors.grey40,
                                            children: "Go online to start receiving Vettes."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: ()=>{
                                var ref;
                                !(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.photoHighUrl) ? message/* message.error */.y.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Oops! Please upload a profile photo in",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                            href: "/settings",
                                            children: "Settings"
                                        }),
                                        " to go online."
                                    ]
                                })) : updateUserPresence({
                                    variables: {
                                        userId,
                                        presence: generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE
                                    }
                                });
                            },
                            loading: mutationLoading,
                            type: "primary",
                            children: "Go online"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayWrapper, {
                $loading: areQueriesLoading,
                $visible: isOnline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Space_styles/* Space */.T, {
                    direction: "vertical",
                    size: 24,
                    align: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                        direction: "vertical",
                        size: 10,
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                src: "/images/glasshour.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                                direction: "vertical",
                                size: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                        $align: "center",
                                        level: 3,
                                        children: "We are waiting for new applicants..."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                        $centered: true,
                                        $size: 15,
                                        $color: theme/* theme.colors.grey40 */.r.colors.grey40,
                                        children: "Once a new interview request comes in, we'll notify you automatically on this screen."
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/ApplicantsList/Empty/SkeletonTable.tsx






const SkeletonTable = (param)=>{
    let { userId , header , loading  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* Table */.i, {
                pagination: false,
                header: header,
                columns: columns_columns({
                    loading
                }),
                dataSource: [
                    ...new Array(4)
                ].map((_, i)=>({
                        key: "skeleton_".concat(i)
                    }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                userId: userId,
                loading: loading
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/ApplicantsList/styles.ts

function ApplicantsList_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-table-thead > tr > th:nth-child(2) {\n    border-right: 1px solid ",
        ";\n  }\n\n  .ant-table-tbody > tr > td:nth-child(2) {\n    border-right: 1px solid ",
        ";\n  }\n"
    ]);
    ApplicantsList_styles_templateObject = function() {
        return data;
    };
    return data;
}

const TableWrap = styled_components_browser_esm/* default.div */.ZP.div(ApplicantsList_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey20;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey20;
});

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/ApplicantsList/index.tsx










const PAGE_SIZE = 4;
const ApplicantsList = (param)=>{
    let { userId , clientId  } = param;
    var ref;
    const { getPath , pages  } = (0,src_router/* useCustomRouter */.cD)();
    const { data , loading  } = (0,generated/* useInternalVetterSessionsQuery */.Ehi)({
        variables: {
            clientId,
            pagination: {
                take: PAGE_SIZE,
                skip: 0
            }
        },
        fetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true
    });
    const sessions = (data === null || data === void 0 ? void 0 : (ref = data.sessions) === null || ref === void 0 ? void 0 : ref.data) || [];
    const header = /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                level: 3,
                $color: theme/* theme.colors.grey100 */.r.colors.grey100,
                children: "Applicants"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: getPath(pages.client.applicants),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "default",
                    children: "View All"
                })
            })
        ]
    });
    if (sessions.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonTable, {
            userId: userId,
            header: header,
            loading: loading
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* Table */.i, {
            pagination: false,
            dataSource: sessions,
            columns: columns,
            scroll: {
                x: "max-content"
            },
            header: header,
            getRowLink: (record)=>{
                return (record === null || record === void 0 ? void 0 : record.id) ? getPath(pages.client.sessions_view({
                    sessionId: record.id
                })) : "#";
            }
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/styles.ts

function DashboardInternalVetter_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  min-height: 100%;\n  width: 100%;\n  flex-direction: column;\n  padding: 36px;\n  overflow-y: auto;\n  z-index: 1;\n"
    ]);
    DashboardInternalVetter_styles_templateObject = function() {
        return data;
    };
    return data;
}
function DashboardInternalVetter_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.ant-card {\n    overflow: hidden;\n    border: none;\n\n    & .ant-card-body {\n      border-radius: 18px;\n      background: linear-gradient(\n          270deg,\n          rgba(118, 62, 217, 0.2) 0%,\n          rgba(118, 62, 217, 0) 100%\n        ),\n        ",
        ";\n    }\n  }\n"
    ]);
    DashboardInternalVetter_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function DashboardInternalVetter_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 53%;\n  min-height: 100%;\n\n  right: 5%;\n  opacity: ",
        ";\n  filter: ",
        ";\n\n  transition: all 0.3s ease-in-out;\n\n  @media (max-width: 1280px) {\n    width: 35%;\n  }\n"
    ]);
    DashboardInternalVetter_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function DashboardInternalVetter_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: ",
        ";\n  transition: opacity 0.3s ease-in-out;\n"
    ]);
    DashboardInternalVetter_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  right: 36px;\n  top: 36px;\n  gap: 12px;\n\n  & > img {\n    object-fit: cover;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}


const DashboardInternalVetter_styles_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(DashboardInternalVetter_styles_templateObject());
const CoolCard = (0,styled_components_browser_esm/* default */.ZP)(atoms_Card/* Card */.Z)(DashboardInternalVetter_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const CirclesImage = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs({
    src: "/images/circlesIllustration.svg"
})(DashboardInternalVetter_styles_templateObject2(), (param)=>{
    let { $active  } = param;
    return !$active ? 0.96 : 1;
}, (param)=>{
    let { $active  } = param;
    return !$active ? "blur(80%)" : "blur(0%)";
});
const LoadingHidden = styled_components_browser_esm/* default.div */.ZP.div(DashboardInternalVetter_styles_templateObject3(), (param)=>{
    let { isLoading  } = param;
    return isLoading ? 0 : 1;
});
const Profile = styled_components_browser_esm/* default.a */.ZP.a(styles_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});

;// CONCATENATED MODULE: ../../libs/pages/src/enterprise-application/DashboardInternalVetter/index.tsx








const DashboardInternalVetter = (param)=>{
    let { userId , clientId  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { router  } = (0,src_router/* useCustomRouter */.cD)();
    const { data: vetterData , loading  } = (0,generated/* useUserPresenceQuery */.Hcm)({
        variables: {
            userId
        },
        onError: ()=>{
            message/* message.error */.y.error("Failed to obtain information about your dashboard. Please, make sure your network is reliably working.");
        },
        onCompleted: (data)=>{
            if (!data.user) {
                message/* message.error */.y.error("You are not authorized to access this page.");
                router.replace("/404");
                return;
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
        className: "dashboard-interviewer",
        $padding: "100px 36px",
        direction: "vertical",
        size: 53,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingHidden, {
                isLoading: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Profile, {
                    href: "/settings",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Text */.xv, {
                            $color: theme/* theme.colors.white */.r.colors.white,
                            $size: 15,
                            $weight: 600,
                            children: [
                                vetterData === null || vetterData === void 0 ? void 0 : (ref = vetterData.user) === null || ref === void 0 ? void 0 : ref.firstName,
                                " ",
                                vetterData === null || vetterData === void 0 ? void 0 : (ref1 = vetterData.user) === null || ref1 === void 0 ? void 0 : ref1.lastName
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (vetterData === null || vetterData === void 0 ? void 0 : (ref2 = vetterData.user) === null || ref2 === void 0 ? void 0 : ref2.photoHighUrl) || "/images/avatar.svg",
                            alt: "profile"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingHidden, {
                isLoading: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Title */.Dx, {
                    $color: theme/* theme.colors.white */.r.colors.white,
                    level: 1,
                    children: [
                        "Hi ",
                        vetterData === null || vetterData === void 0 ? void 0 : (ref3 = vetterData.user) === null || ref3 === void 0 ? void 0 : ref3.firstName,
                        "!"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                $fullWidth: true,
                direction: "vertical",
                size: 22,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoolCard, {
                        disableFillAvailableHeight: true,
                        innerRowFullWidth: true,
                        noMaxWidth: true,
                        disableMargins: true,
                        disablePaddings: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatsChart, {
                                clientId: clientId,
                                userId: userId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CirclesImage, {
                                $active: (vetterData === null || vetterData === void 0 ? void 0 : (ref4 = vetterData.user) === null || ref4 === void 0 ? void 0 : ref4.presence) === generated/* UserPresenceEnum.BUSY */.kWY.BUSY || (vetterData === null || vetterData === void 0 ? void 0 : (ref5 = vetterData.user) === null || ref5 === void 0 ? void 0 : ref5.presence) === generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Card/* Card */.Z, {
                        disableFillAvailableHeight: true,
                        innerRowFullWidth: true,
                        noMaxWidth: true,
                        disableMargins: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicantsList, {
                            userId: userId,
                            clientId: clientId
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/index.tsx + 5 modules
var DashboardLayout = __webpack_require__(27987);
;// CONCATENATED MODULE: ./pages/dashboard/index.tsx






/**
 * @returns For Client Interviewers and Admins coming through enterprise app: DashboardInternalVetter
 * For Client Managers and Admins coming through admin app > Clients > Manage: Dashboard
 */ const dashboard_Dashboard = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
        hasStatusToggle: true,
        overflowY: "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirebaseClaims/* FirebaseClaims */.h, {
            required: {
                id: true,
                role: true,
                clientId: true
            },
            children: (param)=>/*#__PURE__*/ {
                let { clientId , id , clientUserPermission , role  } = param;
                return (0,jsx_runtime.jsx)(RouterQuery/* RouterQuery */.d, {
                    allowEmpty: true,
                    children: (queryParams)=>clientUserPermission === generated/* ClientUserPermissionEnum.MANAGE */.Gfl.MANAGE || role === generated/* UserRoleEnum.ADMIN */.tGl.ADMIN && queryParams.cliendId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard, {
                            clientId: clientId,
                            userId: id
                        }) : clientUserPermission === generated/* ClientUserPermissionEnum.INTERVIEW */.Gfl.INTERVIEW || role === generated/* UserRoleEnum.ADMIN */.tGl.ADMIN && !queryParams.cliendId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardInternalVetter, {
                            clientId: clientId,
                            userId: id
                        }) : null
                });
            }
        })
    });
};
/* harmony default export */ var dashboard = (dashboard_Dashboard);


/***/ }),

/***/ 52854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": function() { return /* binding */ FAILED_STATUSES; },
/* harmony export */   "eV": function() { return /* binding */ IN_PROGRESS_STATUSES; },
/* harmony export */   "r4": function() { return /* binding */ ISSUE_TYPE_OPTIONS; },
/* harmony export */   "x8": function() { return /* binding */ getIssueDescriptionByIssueType; }
/* harmony export */ });
/* unused harmony exports WAITING_FOR_VETTER_CONNECT_STATUSES, REPEATABLE_STATUSES, NON_REPEATABLE_STATUSES, VETTED_STATUSES, SessionStatusFilterEnum, COMPLETED_STATUSES, mapFilterToSessionStatus, mapStatusToVetted, mapRecommendedToPassed, mapInterviewer, parseClientSessionPerformanceData */
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60696);
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_prisma_client__WEBPACK_IMPORTED_MODULE_0__);

// For interview now button states
const WAITING_FOR_VETTER_CONNECT_STATUSES = [
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.LOOKING_FOR_VETTER,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.LOOKING_FOR_VETTER_TIMED_OUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_ACCEPT_SESSION_REQUEST,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.VETTER_REQUEST_TIMED_OUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.VETTER_REJECTED_SESSION_REQUEST
];
// 1. Session statuses
const REPEATABLE_STATUSES = [
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.LOOKING_FOR_VETTER,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.LOOKING_FOR_VETTER_TIMED_OUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_ACCEPT_SESSION_REQUEST,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_PICKUP_CALL,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_PRESS_DIGIT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_APPLICANT_TO_PICKUP_CALL,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.VETTER_DID_NOT_PICKUP_CALL,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.VETTER_REJECTED_SESSION_REQUEST,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.VETTER_REQUEST_TIMED_OUT
];
const NON_REPEATABLE_STATUSES = [
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_CONFIRM_APPLICANT_PICKED_UP,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.SESSION_IN_PROGRESS,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.APPLICANT_DROPPED_FROM_CALL,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.VETTER_DROPPED_FROM_CALL,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_PROVIDE_FEEDBACK
];
const FAILED_STATUSES = [
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.APPLICANT_WAS_NOT_REACHABLE,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.APPLICANT_DID_NOT_PICKUP_CALL,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.VETTER_CLAIMS_APPLICANT_DID_NOT_PICKUP_CALL,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_CONFIRM_APPLICANT_PICKED_UP_TIMED_OUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.WAITING_FOR_VETTER_TO_PROVIDE_FEEDBACK_TIMED_OUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.CALL_DROPPED_TIMED_OUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.SESSION_GLOBAL_TIMED_OUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.SESSION_TERMINATED_BY_ADMIN,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.SESSION_FINISHED_WITH_AN_ISSUE
];
const VETTED_STATUSES = [
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.APPLICANT_DID_NOT_PASS_KNOCKOUT,
    _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionStatus.SESSION_FINISHED_SUCCESSFULLY
];
var SessionStatusFilterEnum;
(function(SessionStatusFilterEnum) {
    SessionStatusFilterEnum["IN_PROGRESS"] = "IN_PROGRESS";
    SessionStatusFilterEnum["COMPLETED"] = "COMPLETED";
})(SessionStatusFilterEnum || (SessionStatusFilterEnum = {}));
const IN_PROGRESS_STATUSES = [
    ...REPEATABLE_STATUSES,
    ...NON_REPEATABLE_STATUSES
];
const COMPLETED_STATUSES = [
    ...FAILED_STATUSES,
    ...VETTED_STATUSES
];
const mapFilterToSessionStatus = (filter)=>{
    return filter === SessionStatusFilterEnum.IN_PROGRESS ? IN_PROGRESS_STATUSES : COMPLETED_STATUSES;
};
const mapStatusToVetted = (status)=>VETTED_STATUSES.find((s)=>s === status) ? 1 : 0;
const mapRecommendedToPassed = (recommended)=>recommended ? 1 : 0;
const mapInterviewer = (vetter)=>{
    if (!vetter) return {
        internalInterviewer: 0,
        externalInterviewer: 0
    };
    if (vetter && (vetter === null || vetter === void 0 ? void 0 : vetter.clientId)) {
        return {
            internalInterviewer: 1,
            externalInterviewer: 0
        };
    } else {
        return {
            externalInterviewer: 1,
            internalInterviewer: 0
        };
    }
};
const parseClientSessionPerformanceData = (records)=>{
    const parsedRecords = records.reduce((map, param)=>{
        let { status , recommended , jobOffer: { id , title: job , clientOfClient: client  } , vetter  } = param;
        if (map.has(id)) {
            const val = map.get(id);
            val["vetted"] = val["vetted"] + mapStatusToVetted(status);
            val["passed"] = val["passed"] + mapRecommendedToPassed(recommended !== null && recommended !== void 0 ? recommended : false);
            val["internalInterviewer"] = val["internalInterviewer"] + mapInterviewer(vetter)["internalInterviewer"];
            val["externalInterviewer"] = val["externalInterviewer"] + mapInterviewer(vetter)["externalInterviewer"];
        } else {
            const val1 = {
                client,
                job,
                vetted: mapStatusToVetted(status),
                passed: mapRecommendedToPassed(recommended !== null && recommended !== void 0 ? recommended : false),
                ...mapInterviewer(vetter)
            };
            map.set(id, val1);
        }
        return map;
    }, new Map());
    return Array.from(parsedRecords.values());
};
const ISSUE_TYPE_OPTIONS = [
    {
        value: _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionReportedIssueType.CALL_LANDED_TO_APPLICANT_VOICEMAIL,
        text: "The call landed in the applicant's voicemail"
    },
    {
        value: _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionReportedIssueType.APPLICANT_CANNOT_SPEAK_NOW,
        text: "The applicant cannot speak right now"
    },
    {
        value: _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionReportedIssueType.VETTER_HANG_UP_UNEXPECTEDLY,
        text: "We got disconnected on my end"
    },
    {
        value: _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionReportedIssueType.APPLICANT_HANG_UP_UNEXPECTEDLY,
        text: "The applicant dropped from the call unexpectedly"
    },
    {
        value: _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionReportedIssueType.COULD_NOT_HEAR_EACH_OTHER,
        text: "We could not hear each other"
    },
    {
        value: _prisma_client__WEBPACK_IMPORTED_MODULE_0__.SessionReportedIssueType.OTHER,
        text: "Other"
    }
];
const getIssueDescriptionByIssueType = (issueType)=>{
    return ISSUE_TYPE_OPTIONS.find((elem)=>elem.value === issueType);
};


/***/ }),

/***/ 35838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "o8": function() { return /* binding */ formatDateOnly; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony export formatInUTC */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43650);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31807);

const formatDate = (value)=>value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value), "MM/dd/yyyy hh:mm aa") : "";
const formatDateOnly = (value)=>value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value), "MM/dd/yyyy") : "";
const formatTime = (value)=>value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value), "hh:mm aa") : "";
const formatInUTC = (value)=>{
    const date = new Date(value);
    return "".concat(format(addMinutes(date, date.getTimezoneOffset()), "dd/MM/yyyy hh:mm aa"), " UTC");
};


/***/ }),

/***/ 72605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useThrottleSubscription; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


const useThrottleSubscription = (throttleFn, throttleWait, subscription, subscriptionOptions)=>{
    const refetch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>(0,lodash__WEBPACK_IMPORTED_MODULE_0__.throttle)(throttleFn, throttleWait), [
        throttleFn,
        throttleWait
    ]);
    subscription({
        fetchPolicy: "no-cache",
        onSubscriptionData: ()=>{
            refetch();
        },
        ...subscriptionOptions
    });
};


/***/ }),

/***/ 72579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ RouterQuery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);




const RouterQuery = (param)=>{
    let { children , fallback , allowEmpty =false  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [isReady, setIsReady] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (allowEmpty) {
            setIsReady(true);
        }
    }, [
        router.query,
        allowEmpty
    ]);
    if (!isReady && (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(router.query)) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: fallback || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children(router.query)
    });
};


/***/ }),

/***/ 94043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ QuestionMarkTooltip; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/QuestionCircleFilled.js
var QuestionCircleFilled = __webpack_require__(50733);
var QuestionCircleFilled_default = /*#__PURE__*/__webpack_require__.n(QuestionCircleFilled);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/QuestionMarkTooltip/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const QuestionMarkIcon = (0,styled_components_browser_esm/* default */.ZP)((QuestionCircleFilled_default()))(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey60;
});

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Tooltip/index.tsx + 1 modules
var Tooltip = __webpack_require__(77435);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/QuestionMarkTooltip/index.tsx



const QuestionMarkTooltip = (tooltipProps)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
        ...tooltipProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionMarkIcon, {})
    });
};


/***/ }),

/***/ 28353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/card/index.js + 3 modules
var card = __webpack_require__(22419);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Card/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin: 0 !important;\n      "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 0 !important;\n      "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          height: fill-available;\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 0;\n  min-height: max-content;\n  padding: 12px;\n  height: 100%;\n  & .ant-card-body {\n    height: 100%;\n  }\n  & .ant-card-head {\n    border-bottom: none;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: 576px) {\n    max-width: ",
        ";\n    padding: 50px 40px 40px 40px;\n    border-radius: 18px;\n    height: ",
        ";\n    width: ",
        ";\n    & .ant-card-body {\n      padding: 0;\n      ",
        ";\n    }\n    margin: 36px;\n  }\n\n  @media (max-height: 576px) and (orientation: landscape) {\n    border-radius: 0;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: block;\n          width: 100%;\n        "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: flex;\n        "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 100%;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}


const Card = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.styles.gradient;
}, (param)=>{
    let { $disableMargins  } = param;
    return $disableMargins && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, (param)=>{
    let { $disablePaddings  } = param;
    return $disablePaddings && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
}, (param)=>{
    let { $noMaxWidth  } = param;
    return $noMaxWidth ? "unset" : "924px";
}, (param)=>{
    let { $height  } = param;
    return $height ? $height : "auto";
}, (param)=>{
    let { $width  } = param;
    return $width ? $width : "auto";
}, (param)=>// height:fill-available messes up the layout on Safari
{
    let { $disableFillAvailableHeight  } = param;
    return !$disableFillAvailableHeight && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
const FullHeightRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject6(), (param)=>{
    let { $innerRowFullWidth  } = param;
    return $innerRowFullWidth ? (0,styled_components_browser_esm/* css */.iv)(_templateObject4()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Card/index.tsx



const Card_Card = (param)=>{
    let { width , height , noMaxWidth =false , innerRowFullWidth =false , disableMargins =false , disablePaddings =false , disableFillAvailableHeight =false , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
        ...props,
        $height: height,
        $width: width,
        $noMaxWidth: noMaxWidth,
        $disableMargins: disableMargins,
        $disablePaddings: disablePaddings,
        $disableFillAvailableHeight: disableFillAvailableHeight,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullHeightRow, {
            $innerRowFullWidth: innerRowFullWidth,
            children: children
        })
    });
};


/***/ }),

/***/ 5924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ getColorByRecommendedValue; },
/* harmony export */   "Jj": function() { return /* binding */ getTextLabelByRecommendedValue; },
/* harmony export */   "vD": function() { return /* binding */ textLabelMappedToRecommendedValue; }
/* harmony export */ });
/* harmony import */ var _vette_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52854);
/* harmony import */ var _vette_data_access__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20229);
/* harmony import */ var _common_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32657);



const textLabelMappedToRecommendedValue = {
    All: undefined,
    Passed: {
        recommended: true,
        status: [
            _vette_data_access__WEBPACK_IMPORTED_MODULE_0__/* .SessionStatusEnum.SESSION_FINISHED_SUCCESSFULLY */ .YpI.SESSION_FINISHED_SUCCESSFULLY
        ]
    },
    Failed: {
        recommended: false,
        status: [
            _vette_data_access__WEBPACK_IMPORTED_MODULE_0__/* .SessionStatusEnum.SESSION_FINISHED_SUCCESSFULLY */ .YpI.SESSION_FINISHED_SUCCESSFULLY
        ]
    },
    Incomplete: {
        status: _vette_common_utils__WEBPACK_IMPORTED_MODULE_1__/* .FAILED_STATUSES */ .BD
    },
    "Knockout failed": {
        status: [
            _vette_data_access__WEBPACK_IMPORTED_MODULE_0__/* .SessionStatusEnum.APPLICANT_DID_NOT_PASS_KNOCKOUT */ .YpI.APPLICANT_DID_NOT_PASS_KNOCKOUT
        ]
    },
    Flagged: {
        flagged: true
    }
};
const getColorByRecommendedValue = (recommended, status)=>{
    if (status && _vette_common_utils__WEBPACK_IMPORTED_MODULE_1__/* .IN_PROGRESS_STATUSES.some */ .eV.some((s)=>s === status)) {
        return _common_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.purple40 */ .r.colors.purple40;
    }
    switch(recommended){
        case true:
            {
                return _common_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.green40 */ .r.colors.green40;
            }
        case false:
            {
                return _common_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.red40 */ .r.colors.red40;
            }
        default:
            {
                return _common_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.grey40 */ .r.colors.grey40;
            }
    }
};
const getTextLabelByRecommendedValue = (recommended, status)=>{
    if (status && _vette_common_utils__WEBPACK_IMPORTED_MODULE_1__/* .IN_PROGRESS_STATUSES.some */ .eV.some((s)=>s === status)) {
        return "In progress";
    }
    if (status === _vette_data_access__WEBPACK_IMPORTED_MODULE_0__/* .SessionStatusEnum.APPLICANT_DID_NOT_PASS_KNOCKOUT */ .YpI.APPLICANT_DID_NOT_PASS_KNOCKOUT && recommended === false) {
        return "Knockout failed";
    }
    if (recommended === true) {
        return "Passed";
    }
    if (recommended === false) {
        return "Failed";
    }
    if (!recommended) {
        return "Incomplete";
    }
    return "unhandled";
};


/***/ }),

/***/ 43057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ SessionStatusBadge; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/vetter/SessionStatusBadge/helpers.ts
var helpers = __webpack_require__(5924);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Warning.js
var Warning = __webpack_require__(35296);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/StatBadge/index.tsx + 1 modules
var StatBadge = __webpack_require__(87803);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/vetter/SessionStatusBadge/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 13.5px 24px;\n      border-radius: 24px;\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 14px;\n  max-height: 20px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}



const styles_StatBadge = (0,styled_components_browser_esm/* default */.ZP)(StatBadge/* StatBadge */.I)(_templateObject1(), (param)=>{
    let { $size  } = param;
    return $size === "large" && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
const InnerWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
const WarnIcon = (0,styled_components_browser_esm/* default */.ZP)(Warning/* default */.Z)(_templateObject3());

// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 3 modules
var tooltip = __webpack_require__(55003);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/QuestionMarkTooltip/index.tsx + 1 modules
var QuestionMarkTooltip = __webpack_require__(94043);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/vetter/SessionStatusBadge/index.tsx






const SessionStatusBadge = (param)=>{
    let { recommended , canceled , size , clickable , status , tooltipText , ...props } = param;
    const textLabel = helpers/* getTextLabelByRecommendedValue */.Jj(recommended, status).toUpperCase();
    const result = textLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StatBadge, {
            $size: size || "small",
            clickable: clickable,
            backgroundColor: helpers/* getColorByRecommendedValue */.CG(recommended, status),
            text: canceled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                        title: "This interview was canceled by a vetter due to technical difficulties. Regardless of that we've attempted to preserve as much information as possible.",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarnIcon, {})
                    }),
                    " ",
                    textLabel
                ]
            }) : textLabel,
            ...props
        })
    }) : null;
    return result ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        align: "middle",
        children: [
            result,
            tooltipText && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionMarkTooltip/* QuestionMarkTooltip */.w, {
                title: tooltipText
            })
        ]
    }) : null;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [746,823,481,6,642,444,103,911,733,604,586,987,165,774,888,179], function() { return __webpack_exec__(55792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);